<template>
  <v-card tile elevation="3" class="pa-5">
    <v-file-input
        v-model="scans"
        counter-string=""
        :rules="fileRules"
        accept="image/*"
        name="scans"
        color="blue darken-4"
        counter
        :label="labelText"
        multiple
        placeholder=""
        prepend-icon="mdi-paperclip"
        outlined
        required
        @change="passScans"
    >
      <template v-slot:selection="{ index, text }">
        <v-chip
            v-if="index < 2"
            color="blue darken-4"
            dark
            label
            small
        >
          <span style="color: #cdcdcd; font-size: 16px">{{ text }}</span>
        </v-chip>

        <span
            v-else-if="index === 2"
            class="text-overline grey--text text--darken-3 mx-2"
        >
        +{{ scans.length - 2 }} Файл(а)
      </span>
      </template>
    </v-file-input>
  </v-card>
</template>

<script>
export default {
  name: "UploadScans",
  data() {
    return {
      scans: [],
      // fileRules: this.props.rules ? this.props.rules : [
      //   v => (!!v[0]) || 'Должен быть как минимум один скан',
      // ],
      fileRules: this.computeRules(),
      errors: []
    }
  },

  props: {
    rules: {
      type: Array,
      required: false,
    },
    labelText: {
      type: String,
      required: true
    }
  },

  methods: {
    passScans () {
      this.$emit('pass', this.scans)
    },

    computeRules () {
      if (this.$props.rules) {
        return this.$props.rules
      } else return [
        v => (!!v[0]) || 'Должно быть как минимум одно изображение',
      ]
    }
  }
}
</script>

<style scoped>

</style>